import { lazy, Suspense } from "react";
import { useNavigate, useParams } from "react-router-dom";

import FullSizeLoading from "components/FullSizeLoading";
import useFetchNewsById from "hooks/api/useFetchNewsById";

const NewsDetailPresenter = lazy(() => import("pages/NewsDetail/pc/NewsDetailPresenter"));

const NewsDetailContainer = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { news, isLoading } = useFetchNewsById(id ?? "");

  const handleNavigateNewsList = () => {
    navigate("/news");
  };

  return (
    <Suspense fallback={<FullSizeLoading />}>
      {isLoading ? (
        <FullSizeLoading />
      ) : (
        <NewsDetailPresenter news={news} handleNavigateNewsList={handleNavigateNewsList} />
      )}
    </Suspense>
  );
};

export default NewsDetailContainer;
